<template>
  <router-view name="page" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Page",
};
</script>
